var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-info-box"},[_c('icon-link-boxes-container',{attrs:{"data":_vm.iconLinkBoxes}}),(_vm.agentData)?_c('div',{staticClass:"agent-container"},[_c('user-box',{attrs:{"data":_vm.agentData}})],1):_vm._e(),_c('nearest-branch-box')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }